"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInstrument = exports.selectInstrument = exports.requestInstruments = exports.receiveInstruments = exports.initSelectedInstrument = exports.fetchInstruments = exports.SET_INSTRUMENT = exports.SELECT_INSTRUMENT = exports.REQUEST_INSTRUMENTS = exports.RECEIVE_INSTRUMENTS = void 0;
var _apiActions = require("./apiActions");
var _config = _interopRequireDefault(require("../../config"));
var _level1Actions = require("./level1Actions");
var _level2Actions = require("./level2Actions");
var _recentTradesActions = require("./recentTradesActions");
var _futuresRecentTradesActions = require("../futures/actions/futuresRecentTradesActions");
var _filterSortSupportedInstruments = _interopRequireDefault(require("../../helpers/filterSortSupportedInstruments"));
var _tickersActions = require("./tickersActions");
var _actions = require("../futures/actions");
var _selectors = require("../futures/selectors");
var _futuresInstrumentsActions = require("../futures/actions/futuresInstrumentsActions");
var _futuresLevel1Actions = require("../futures/actions/futuresLevel1Actions");
var _futuresLevel2Actions = require("../futures/actions/futuresLevel2Actions");
var _userActions = require("./userActions");
var _marginInstrumentSelectors = require("../margin/selectors/marginInstrumentSelectors");
var _instrumentPositionSelectors = require("../selectors/instrumentPositionSelectors");
var _selectors2 = require("../margin/selectors");
var _actions2 = require("../margin/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var fetchInstruments = exports.fetchInstruments = function fetchInstruments() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var selectedInstrumentId, instruments, filteredInstruments, instrumentId, store, betaOptedIn, isFutures, currentInstrumentId, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            selectedInstrumentId = options.selectedInstrumentId;
            _context.p = 1;
            dispatch(requestInstruments());
            _context.n = 2;
            return dispatch((0, _apiActions.callAPI)('GetInstruments', {
              OMSId: 1
            }));
          case 2:
            instruments = _context.v;
            filteredInstruments = (0, _filterSortSupportedInstruments["default"])(instruments);
            dispatch(receiveInstruments(filteredInstruments));
            if (filteredInstruments.length) {
              _context.n = 3;
              break;
            }
            return _context.a(2);
          case 3:
            instrumentId = filteredInstruments.some(function (i) {
              return i.InstrumentId === selectedInstrumentId;
            }) ? selectedInstrumentId : filteredInstruments[0].InstrumentId;
            dispatch(setInstrument(instrumentId));
            store = getState();
            betaOptedIn = localStorage.getItem('betaOptedIn');
            isFutures = (0, _userActions.isFuturesAccount)(store);
            currentInstrumentId = isFutures ? (0, _selectors.futuresSelectedInstrumentIdSelector)(store) : (0, _instrumentPositionSelectors.selectedInstrumentIdSelector)(store);
            if (currentInstrumentId !== instrumentId && !store.apexCore.level2.fetching && betaOptedIn !== 'true') {
              dispatch((0, _level2Actions.subscribeToLevel2)(instrumentId));
            }
            if (!_config["default"].global.privateMarketData) {
              if (Object.keys(store.apexCore.level1).length == 0) {
                dispatch((0, _level1Actions.getAllLevel1Data)(filteredInstruments));
              }
              if (betaOptedIn !== 'true') {
                dispatch((0, _level1Actions.getLevel1Data)(instrumentId));
                dispatch((0, _level1Actions.subscribeToLevel1)(selectedInstrumentId));
                if (store.recentTrades.fetching) {
                  dispatch((0, _recentTradesActions.getRecentTrades)(instrumentId));
                  dispatch((0, _recentTradesActions.subscribeToRecentTrades)());
                }
              }
              dispatch((0, _tickersActions.fetchTickers)());
              dispatch((0, _tickersActions.subscribeToTickers)());
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error(_t);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var SELECT_INSTRUMENT = exports.SELECT_INSTRUMENT = 'SELECT_INSTRUMENT';
var selectInstrument = exports.selectInstrument = function selectInstrument(instrumentId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var state, OMSID, isFuturesActive, isMarginActive, selectedAccountId, selectedInstrumentId, futuresSelectedInstrumentId, _state$auth, isAuthenticated, betaOptedIn;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            state = getState();
            OMSID = state.user.userInfo.OMSId;
            isFuturesActive = (0, _selectors.isFuturesActiveSelector)(state);
            isMarginActive = (0, _selectors2.isMarginActiveSelector)(state);
            selectedAccountId = (0, _selectors.selectedAccountIdSelector)(state);
            selectedInstrumentId = state.apexCore.instrument.selectedInstrumentId;
            futuresSelectedInstrumentId = (0, _selectors.futuresSelectedInstrumentIdSelector)(state);
            if (isFuturesActive) {
              // unsubscribe from default instruments data if Futures account is selected
              if (selectedInstrumentId !== undefined) {
                dispatch((0, _level1Actions.unsubscribeLevel1)(selectedInstrumentId));
                dispatch((0, _level2Actions.unsubscribeLevel2)(selectedInstrumentId));
                dispatch((0, _recentTradesActions.unsubscribeRecentTrades)(selectedInstrumentId));
                dispatch((0, _tickersActions.unsubscribeTicker)(selectedInstrumentId));
              }
              dispatch((0, _futuresInstrumentsActions.setFuturesInstrument)(instrumentId));
              localStorage.setItem('selectedFuturesInstrumentId', instrumentId);
              dispatch((0, _futuresLevel1Actions.getAllFuturesLevel1Data)());
              dispatch((0, _futuresLevel1Actions.unsubscribeFuturesLevel1)(futuresSelectedInstrumentId));
              dispatch((0, _futuresLevel1Actions.getFuturesLevel1Data)(instrumentId));
              dispatch((0, _futuresLevel1Actions.subscribeToFuturesLevel1)());
              // if (store.recentTrades.fetching) {
              dispatch((0, _futuresRecentTradesActions.unsubscribeRecentFuturesTrades)(futuresSelectedInstrumentId));
              dispatch((0, _futuresRecentTradesActions.getRecentFuturesTrades)(instrumentId));
              dispatch((0, _futuresRecentTradesActions.subscribeToRecentFuturesTrades)());
              // }
              dispatch((0, _futuresLevel2Actions.initFuturesLevel2Subscription)(instrumentId));
              dispatch((0, _actions.unsubscribeFuturesTicker)(futuresSelectedInstrumentId)).then(function () {
                dispatch((0, _actions.fetchFuturesTickers)());
                dispatch((0, _actions.subscribeToFuturesTickers)());
              });
              dispatch((0, _actions.getContractDetails)({
                OMSID: OMSID,
                InstrumentId: instrumentId,
                AccountId: selectedAccountId
              }));
            } else {
              // unsubscribe from Futures instruments data if non-futures account is selected
              isAuthenticated = (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : _state$auth.isAuthenticated;
              if (isAuthenticated && futuresSelectedInstrumentId !== undefined) {
                dispatch((0, _futuresLevel1Actions.unsubscribeFuturesLevel1)(futuresSelectedInstrumentId));
                dispatch((0, _futuresLevel2Actions.stopFuturesLevel2Subscription)(futuresSelectedInstrumentId));
                dispatch((0, _futuresRecentTradesActions.unsubscribeRecentFuturesTrades)(futuresSelectedInstrumentId));
                dispatch((0, _actions.unsubscribeFuturesTicker)(futuresSelectedInstrumentId));
              }
              dispatch(setInstrument(instrumentId));
              localStorage.setItem('selectedInstrumentId', instrumentId);
              dispatch((0, _level1Actions.unsubscribeLevel1)(selectedInstrumentId));
              dispatch((0, _level2Actions.unsubscribeLevel2)(selectedInstrumentId));
              dispatch((0, _level1Actions.getLevel1Data)(instrumentId));

              // resubscribe to level2
              betaOptedIn = localStorage.getItem('betaOptedIn');
              if (betaOptedIn !== 'true') {
                dispatch((0, _level1Actions.subscribeToLevel1)(instrumentId));
                // Always subscribe to level2 when switching to non-futures account
                dispatch((0, _level2Actions.subscribeToLevel2)(instrumentId));
              }
              if (!_config["default"].global.privateMarketData) {
                if (betaOptedIn !== 'true') {
                  // resubscribe to trades
                  dispatch((0, _recentTradesActions.unsubscribeRecentTrades)(selectedInstrumentId));
                  dispatch((0, _recentTradesActions.getRecentTrades)(instrumentId));
                  dispatch((0, _recentTradesActions.subscribeToRecentTrades)());
                }
                dispatch((0, _tickersActions.unsubscribeTicker)(selectedInstrumentId)).then(function () {
                  dispatch((0, _tickersActions.fetchTickers)());
                  dispatch((0, _tickersActions.subscribeToTickers)());
                });
              }

              // Fetch instrument verification level config for margin accounts
              if (isMarginActive && selectedAccountId) {
                dispatch((0, _actions2.getInstrumentVerificationLevelConfig)(OMSID, selectedAccountId));
              }
            }
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var initSelectedInstrument = exports.initSelectedInstrument = function initSelectedInstrument(symbolFromUrl) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var state, isFutures, isMarginActive, selectedInstrumentId, selectedFuturesInstrumentId, instruments, normalizeSymbol, symbol, matchedInstrument, instrumentToSet;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            state = getState();
            isFutures = (0, _userActions.isFuturesAccount)(state);
            isMarginActive = (0, _selectors2.isMarginActiveSelector)(state);
            selectedInstrumentId = (0, _instrumentPositionSelectors.selectedInstrumentIdSelector)(state);
            selectedFuturesInstrumentId = (0, _selectors.futuresSelectedInstrumentIdSelector)(state);
            instruments = isFutures ? (0, _selectors.futuresInstrumentsSelector)(state) : isMarginActive ? (0, _marginInstrumentSelectors.instrumentSelectorMarginInstruments)(state) : (0, _instrumentPositionSelectors.instrumentSelectorEnabledInstruments)(state);
            if (!(!instruments || instruments.length === 0)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            normalizeSymbol = function normalizeSymbol(i) {
              return "".concat(i.Product1Symbol).concat(i.Product2Symbol).toUpperCase();
            };
            symbol = symbolFromUrl === null || symbolFromUrl === void 0 ? void 0 : symbolFromUrl.toUpperCase(); // Try to match symbol from URL
            matchedInstrument = instruments.find(function (i) {
              return normalizeSymbol(i) === symbol;
            }); // Fallback to first instrument
            instrumentToSet = matchedInstrument !== null && matchedInstrument !== void 0 ? matchedInstrument : instruments[0];
            if (!isFutures) {
              _context3.n = 3;
              break;
            }
            if (!(selectedFuturesInstrumentId !== instrumentToSet.InstrumentId)) {
              _context3.n = 2;
              break;
            }
            _context3.n = 2;
            return dispatch(selectInstrument(instrumentToSet.InstrumentId));
          case 2:
            return _context3.a(2);
          case 3:
            if (!(!isFutures && selectedInstrumentId !== instrumentToSet.InstrumentId)) {
              _context3.n = 4;
              break;
            }
            _context3.n = 4;
            return dispatch(selectInstrument(instrumentToSet.InstrumentId));
          case 4:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var SET_INSTRUMENT = exports.SET_INSTRUMENT = 'SET_INSTRUMENT';
var setInstrument = exports.setInstrument = function setInstrument(instrumentId) {
  return {
    type: SET_INSTRUMENT,
    payload: instrumentId
  };
};
var REQUEST_INSTRUMENTS = exports.REQUEST_INSTRUMENTS = 'REQUEST_INSTRUMENTS';
var requestInstruments = exports.requestInstruments = function requestInstruments() {
  return {
    type: REQUEST_INSTRUMENTS,
    payload: ''
  };
};
var RECEIVE_INSTRUMENTS = exports.RECEIVE_INSTRUMENTS = 'RECEIVE_INSTRUMENTS';
var receiveInstruments = exports.receiveInstruments = function receiveInstruments(instruments) {
  return {
    type: RECEIVE_INSTRUMENTS,
    payload: instruments
  };
};